import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

/**
 * @function
 * @name Pro
 * @param {Object} proCategories - the user's pro subcategories
 * Returns the markup of the user pro subcategories
 */

const Pro = ({proCategories}) => (
    <div className="pro-wrapper">
        <p>{i18n.t('seller_card.pro.verified_by')}</p>
        <label className="pro-badge hint--left" data-hint={i18n.t('seller_card.pro.tooltip_seller')}>{i18n.t('general.pro')}</label>
        <ul>
            {proCategories.map((subcategory, index) => (
                <li key={index}>
                    {subcategory.name}
                </li>
            ))}
        </ul>
    </div>
);

Pro.propTypes = {
    proCategories: PropTypes.array
};

export default Pro;


// WEBPACK FOOTER //
// ./src/components/pro/index.js